import React from 'react';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    // eslint-disable-next-line no-console
    console.error('[ErrorBoundary]', error, info.componentStack);
  }

  render() {
    const { error } = this.state;
    const { children, fallbackTitle = 'Something went wrong' } = this.props;

    if (!error) {
      return children;
    }

    return (
      <div className="app-error-boundary" role="alert">
        <h2>{fallbackTitle}</h2>
        <p>{error.message || 'An unexpected error occurred.'}</p>
        <button
          type="button"
          onClick={() => this.setState({ error: null })}
        >
          Try again
        </button>
      </div>
    );
  }
}

export default ErrorBoundary;
